import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { BUSINESS } from "../../config/business";
import "./notfound.css";

export default function NotFound() {
  useEffect(() => {
    document.title = `Page not found | ${BUSINESS.brand}`;
  }, []);

  return (
    <div className="notfound-shell">
      <Header />

      <main className="notfound-main">
        <p className="notfound-code">404</p>
        <h1>We couldn't find that page</h1>
        <p className="notfound-text">
          The link may be out of date, or the address may have been typed
          incorrectly. Here is where you might want to go instead:
        </p>

        <div className="notfound-links">
          <Link className="btn btn-success" to="/">
            Home
          </Link>
          <Link className="btn btn-light border" to="/bike_catalog">
            E-Cycles
          </Link>
          <Link className="btn btn-light border" to="/Part_catalog">
            Parts &amp; Accessories
          </Link>
          <Link className="btn btn-light border" to="/service">
            Service
          </Link>
          <Link className="btn btn-light border" to="/contact">
            Contact Us
          </Link>
        </div>

        <p className="notfound-help">
          Still stuck? Call us on{" "}
          <a href={`tel:+${BUSINESS.phoneRaw}`}>{BUSINESS.phone}</a> or email{" "}
          <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>.
        </p>
      </main>

      <Footer />
    </div>
  );
}
